import { removeMimeFromBase64, toBase64 } from "common/utils/formats"
import getFileTypeToTheBE from "common/utils/getFileTypeToTheBE"
import { split } from "lodash"

const mapNewFacturaRecurrenteToPost = async ({
  librador,
  librado,
  colorSelected,
  total,
  archivosAdjuntos,
  retencionTipoId,
  divisa,
  retencionPorcentaje,
  conceptos,
  ...documento
}: $TSMigrationFixMe) => {
  return {
    ...documento,
    cliente: librado,
    usuario: librador,
    codigoHex: colorSelected,
    divisa,
    importe: total,
    origenDocumento: 4, // Vuzoon
    impuestoRetenidoId: retencionTipoId,
    impuestoRetenido: retencionTipoId,
    tarifaImpuesto: retencionPorcentaje,
    conceptos: conceptos.map((concepto: $TSMigrationFixMe) => ({
      ...concepto,
      impuestoRepercutidoId: concepto.impuestoArticuloTipoId,
      tarifaImpuesto: concepto.impuestoArticuloPorcentaje,
    })),
    archivosAdjuntos: await Promise.all(
      archivosAdjuntos.map(async (archivoAdjunto: $TSMigrationFixMe) => ({
        nombre: split(archivoAdjunto.name, ".", 1)[0],
        tipo: getFileTypeToTheBE(archivoAdjunto.name),
        // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa...
        fileAsBase64: removeMimeFromBase64(await toBase64(archivoAdjunto)),
      }))
    ),
    intervalo: documento.intervalo,
    fechaFin: documento.fechaFin,
    fechaInicio: documento.fechaInicio,
    fechaOperacion: documento.fechaOperacion
      ? new Date(documento.fechaOperacion)
      : null,
  }
}

export { mapNewFacturaRecurrenteToPost }
